import { useQuery } from '@apollo/client';

import { GetToolboxCollectionsCountDocument } from './getToolboxCollectionsCount.gql';

const useGetToolboxCollectionsCount = () => {
  const { data, ...hook } = useQuery(GetToolboxCollectionsCountDocument);

  const count = data?.toolboxCollectionsCount.totalCount;

  return {
    ...hook,
    count,
  };
};

export default useGetToolboxCollectionsCount;
